import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';
import {MenuItem} from "primeng/api";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent {
  @Input() products: any[] = [];
  @Output() selectedFilter = new EventEmitter<ElementRef>();
  items: MenuItem[] | undefined;
  filters: any = {
    Brands: ['Realme', 'Samsung', 'Xiaomi', 'Oppo', 'Vivo', 'Tecno', 'Apple'],
    Colors: ['Black', 'Green', 'Lime Green', 'Glittey White', 'Startail Black'],
    Storage: ['64GB', '128GB', '256GB', '512GB', '1TB'],
    RAM: ['4GB', '6GB', '8GB', '16GB', '32GB'],
    Price_Range: ['Below ₹10000', '₹10000 - ₹20000', '₹20000 - ₹50000', '₹50000 - ₹100000', 'Above ₹100000'],
    Discounts: ['10%', '20%', '30%', '40%', 'Above 50%'],
    Display_Type: ['AMOLED', 'LCD', 'OLED'],
    Display_Size: ['5.5"', '6.1"', '6.7"', 'Above 6.7"'],
    Battery_Size: ['3000mAh', '4000mAh', '5000mAh', 'Above 5000mAh'],
    Processors: ['Snapdragon', 'MediaTek', 'Exynos', 'Apple', 'Other']
  };

  selectedFilters: any = {};

  ngOnInit() {

  }

  toggleFilter(category: string, value: string) {
    let selected = this.selectedFilters[category];
    if (!selected) selected = this.selectedFilters[category] = [];
    if (selected.includes(value)) {
      this.selectedFilters[category] = selected.filter((item: string) => item !== value);
    } else {
      this.selectedFilters[category].push(value);
    }
  }

  applyFilters() {
    this.selectedFilter.emit(this.selectedFilters);
  }
}
